import type { UseQueryResponse } from '@urql/vue';
import { computed } from 'vue';
import type { InfrastructureResponse } from './infrastructure-response';

export class InfrastructureResponseBuilder<Result, Mapped = Result> {
  static fromQuery<T>(query: UseQueryResponse<T>) {
    const noopMapper = () => query.data.value;
    return new InfrastructureResponseBuilder(query, noopMapper);
  }

  private constructor(
    private query: UseQueryResponse<Result>,
    private mapper: (result: Result) => Mapped,
  ) {}

  withMapper<T>(
    mapper: (result: Result) => T,
  ): InfrastructureResponseBuilder<Result, T> {
    return new InfrastructureResponseBuilder(this.query, mapper);
  }

  build(): InfrastructureResponse<Mapped> {
    const data = computed(() => {
      if (this.query.data.value) {
        return this.mapper(this.query.data.value);
      } else {
        return undefined;
      }
    });

    const error = computed(() =>
      this.query.error.value?.message
        ? { message: this.query.error.value.message }
        : null,
    );

    this.query.resume();
    return { data, fetching: this.query.fetching, error };
  }
}
